import { DoudianPeriodPurchaseInfo } from "@/dto/order/DouDianOrderExtraInfoDTO";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderItemDTO from "@/dto/order/OrderItemDTO";
import { findPeriodPurchaseInfoByOrderItemOriginalId, getPeriodPurchaseDeliverTypeInfo } from "@/utils/doudian";
import { observer } from "mobx-react-lite";
import moment from "moment";
import React from "react";

interface DouDianPeriodPurchaseInfoProps {
    order: OrderDTO;
    orderItem: OrderItemDTO;
}

const DouDianPeriodPurchaseInfo: React.FC<DouDianPeriodPurchaseInfoProps> = function (props) {
    const { order, orderItem } = props;

    if (!order.doudianOrderExtraInfo?.periodPurchaseInfoList?.length) return null;

    const orderItemLatestPeriodPurchaseInfo: DoudianPeriodPurchaseInfo = findPeriodPurchaseInfoByOrderItemOriginalId(
        order.doudianOrderExtraInfo.periodPurchaseInfoList,
        orderItem.originalId,
    );

    if (!orderItemLatestPeriodPurchaseInfo) return null;

    let deliverTypeInfo = getPeriodPurchaseDeliverTypeInfo(orderItemLatestPeriodPurchaseInfo.deliverType);

    return (
        <p>
            周期购:
            <span className="text-secondary">
                <span>
                    配送次数:{orderItemLatestPeriodPurchaseInfo.periodNum}/
                    {orderItemLatestPeriodPurchaseInfo.totalPeriodNum}，{deliverTypeInfo}:
                    {moment(orderItemLatestPeriodPurchaseInfo.deliverTime).format("YYYY-MM-DD")}
                </span>
            </span>
        </p>
    );
};

export default observer(DouDianPeriodPurchaseInfo);
